import PropTypes from 'prop-types'
import { formatearFecha } from '../../helpers/helper'
import LinkButton from '../../ui/LinkButton'
import styles from './Pedido.module.css'

const MERCADO_PAGO = 7

export const PedidoBody = ({ fechaPedido, pedidoItem, esVentas, tienePercepcionesPendientes }) => {
  const {
    idPublicacion,
    idVendedor,
    idPedidoItem,
    fechaDespachado,
    esItemCalificado,
    esVendedorCalificado,
    fechaRecibido,
    estadoNombre,
    descripcionEstado,
    medioPago,
    tipoPagoMP,
    idMedioPago
  } = pedidoItem

  const yaCalificado = esItemCalificado === 1 || esVendedorCalificado === 1

  const pathCalificarProducto = `/CalificarProducto/${idPublicacion}/${idVendedor}/${idPedidoItem}`

  let descripcionPedido = ''

  if (esVentas && tienePercepcionesPendientes) {
    descripcionPedido = 'para editar y confirmar las percepciones ir a "Gestionar pedido"'
  } else if (descripcionEstado) {
    descripcionPedido = descripcionEstado
  }

  return (
    <div className={styles.pedidoBody}>
      <div>
        <div className={styles.pedidoDescripcion}>
          <span>
            <i className="fa fa-calendar-o" aria-hidden="true" />
            <strong>Compra:</strong> {formatearFecha(fechaPedido, 'F')}
          </span>
          <span>
            <i className="fa fa-truck" aria-hidden="true" />
            <strong>Enviado:</strong> {formatearFecha(fechaDespachado, 'F')}
          </span>
          <span>
            <i className="fa fa-gift" aria-hidden="true" />
            <strong>Entregado:</strong> {formatearFecha(fechaRecibido, 'F')}
          </span>
          <span>
            <i className="fa fa-credit-card" aria-hidden="true"></i>
            <strong>Método de pago:</strong>{' '}
            {tipoPagoMP && idMedioPago === MERCADO_PAGO && `${tipoPagoMP} mediante `}
            {medioPago || ''}
          </span>
        </div>
        <div className={styles.estado}>
          <strong>Estado del envio: </strong>
          {`${estadoNombre} ${descripcionPedido && `(${descripcionPedido})`}`}
        </div>
      </div>
      <div className={styles.items}>
        {!esVentas && (
          <LinkButton
            to={pathCalificarProducto}
            className={`${styles.califButton} ${yaCalificado ? styles.disabledButton : ''}`}
          >
            <i className="fa fa-star" aria-hidden="true" />
            Calificar Producto
          </LinkButton>
        )}
        <LinkButton
          to={{
            pathname: `/PedidoItem/${idPedidoItem}`,
            state: { ...pedidoItem, fechaPedido, esVentas }
          }}
          className={styles.califButton}
        >
          <i className="fa fa-search" aria-hidden="true" />
          Ver Detalle
        </LinkButton>
      </div>
    </div>
  )
}

PedidoBody.propTypes = {
  fechaPedido: PropTypes.string.isRequired,
  pedidoItem: PropTypes.shape({
    idPublicacion: PropTypes.number,
    idVendedor: PropTypes.number,
    idPedidoItemEstado: PropTypes.number,

    idPedidoItem: PropTypes.number,
    fechaDespachado: PropTypes.string,
    esItemCalificado: PropTypes.number,
    esVendedorCalificado: PropTypes.number,
    fechaRecibido: PropTypes.string,
    estadoNombre: PropTypes.string,
    descripcionEstado: PropTypes.string,
    idMedioPago: PropTypes.number,
    medioPago: PropTypes.string,
    tipoPagoMP: PropTypes.string
  }).isRequired,
  esVentas: PropTypes.bool.isRequired,
  tienePercepcionesPendientes: PropTypes.bool.isRequired
}
